<template>
  <EstimatedDeliveryStatsKpi
    :is-visible="true"
    :label="$t('names.eCPM', { n: 1 })"
    :value="value"
    :icon="iconColoredCPM"
    :is-loading="isLoading"
    :is-money="true"
    :show-tooltip="showTooltip"
    :tooltip-content="tooltipContent"
    trend-format="+0a"
    data-entity-type="siteCount">
  </EstimatedDeliveryStatsKpi>
</template>

<script setup lang="ts">
  import { markRaw } from 'vue';

  import EstimatedDeliveryStatsKpi from '@/common/components/estimated-delivery-stats/EstimatedDeliveryStatsKpi.vue';
  import { IconColoredCPM } from '@/common/icons/colored';

  const iconColoredCPM = markRaw(IconColoredCPM);

  interface IEstimatedDeliveryStatsKpiImpressionsProps {
    isLoading: boolean;
    value?: string;
    showTooltip?: boolean;
    tooltipContent?: string;
  }
  const props = withDefaults(defineProps<IEstimatedDeliveryStatsKpiImpressionsProps>(), {
    showTooltip: false,
    tooltipContent: '',
  });
</script>
